<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{'--width': widthVar}"  class="pageHeader">课程导入</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <!-- <el-form-item label="组织结构">
          <el-tag>{{$refs.organDia?$refs.organDia.nodeArrName:''}}</el-tag>&nbsp;<el-button type="primary" @click="dialogOpen">选择</el-button>
        </el-form-item> -->
        <!-- <el-form-item :label="`${$store.state.themeTitle}室`">
          <el-select v-model="formInline.training_no" filterable clearable :placeholder="`请选择${$store.state.themeTitle}室`">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name" :value="item.id"></el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item label="状态">
          <el-select v-model="formInline.status" clearable placeholder="请选择状态">
            <el-option label="待审核" value="apply"></el-option>
            <el-option label="已通过" value="pass"></el-option>
            <el-option label="已拒绝" value="refuse"></el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item label="日期">
          <el-date-picker v-model="formInline.date" type="date" placeholder="选择日期">
          </el-date-picker>
        </el-form-item> -->
        <!-- <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd()">新增</el-button>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="downloadFile">下载课程导入模板</el-button>
        </el-form-item>
        <el-form-item>
          <Importt :uploadSectionFile="uploadSectionFile"  @refresh="handleQuery" :action="action" :params="params"     :btnTitle="btnTitle"></Importt>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" @click="handleExport">{{exportTitle}}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handlePrint">打印</el-button>
        </el-form-item> -->
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" ref="table" border style="width: 100%">
        <custom-table-column fixed prop="course_name" label="课程名称" width="180">
        </custom-table-column>
        <custom-table-column fixed prop="training_name" :label="`${$store.state.themeTitle}室名称`" width="160">
        </custom-table-column>
        <custom-table-column prop="term" label="学期" width="160">
        </custom-table-column>
        <custom-table-column prop="week" label="周次" width="100">
        </custom-table-column>
        <custom-table-column prop="sector" label="节次" width="100">
        </custom-table-column>
        <custom-table-column label="状态" width="150" prop="status" :formatter="format_status_str">
        </custom-table-column>
        <custom-table-column prop="structure_1" label="所属院系" width="180">
        </custom-table-column>
        <custom-table-column prop="structure_2" label="专业" width="180">
        </custom-table-column>
        <custom-table-column prop="class_name" label="班级名称" width="180">
        </custom-table-column>
        <custom-table-column prop="item_num" label="项目数" width="100">
        </custom-table-column>
        <custom-table-column prop="people_number" label="人数" width="100">
        </custom-table-column>
        <custom-table-column prop="class_hour" label="上课学时数（小时）" width="140">
        </custom-table-column>
        <custom-table-column prop="teacher" label="指导教师" width="120">
        </custom-table-column>
        <custom-table-column prop="class_content" label="课程内容" min-width="220" show-overflow-tooltip>
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
            <!-- <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button> -->
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false"  :title="title" :visible.sync="centerDialogVisible" width="706px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="学  期" prop="term">
          <el-select v-model="ruleForm.term" clearable placeholder="请选择学年学期" style="width:216px;">
            <el-option v-for="(item, index) in $store.state.termms" :key="index" :label="item.term"
              :value="item.term"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="序  号" prop="serial_number">
          <el-input v-model="ruleForm.serial_number" placeholder="请输入编号" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="班级名称" prop="class_name">
          <el-input v-model="ruleForm.class_name" placeholder="请输入班级名称" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="课程名称" prop="course_name">
          <el-input v-model="ruleForm.course_name" placeholder="请输入课程名称" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item :label="`${$store.state.themeTitle}室`" prop="training_no">
          <el-select v-model="ruleForm.training_no" filterable style="width:216px;" :placeholder="`请选择${$store.state.themeTitle}室`" @change="handleClassChange">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name" :value="item.training_no"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="开始时间" required style="width:568px"> -->
        <!-- <el-col :span="11"> -->
        <el-form-item label="开始时间" prop="lesson_time">
          <el-date-picker type="datetime" placeholder="选择开始时间" v-model="ruleForm.lesson_time" style="width:216px;"></el-date-picker>
        </el-form-item>
        <el-form-item label="授课时长" prop="class_minute">
          <el-input v-model="ruleForm.class_minute" placeholder="请输入授课时长" style="width:198px;"></el-input> 分
        </el-form-item>
        <el-form-item label="仪器及数量" prop="instrument">
          <el-input type="textarea" v-model="ruleForm.instrument" style="width:532px;"></el-input>
        </el-form-item>
        <el-form-item label="指导教师" prop="teacher">
          <el-input v-model="ruleForm.teacher" placeholder="请输入指导教师" style="width:216px;"></el-input>
        </el-form-item>
        <!-- </el-col>
          <el-col class="line" :span="2" style="text-align:center;">-</el-col>
          <el-col :span="11">
            <el-form-item prop="order_end">
              <el-date-picker type="datetime" placeholder="选择结束时间" v-model="ruleForm.order_end" style="width:216px;"></el-date-picker>
            </el-form-item>
          </el-col> -->
        <!-- </el-form-item> -->
        <el-form-item label="人  数" prop="people_number">
          <el-input v-model.number="ruleForm.people_number" placeholder="请输入人数" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="课程内容" prop="class_content">
          <el-input type="textarea" v-model="ruleForm.class_content" style="width:532px;"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="comment">
          <el-input type="textarea" v-model="ruleForm.comment" style="width:532px;"></el-input>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type=='add'" @click="submitForm('ruleForm')">确认</el-button>
          <el-button type="primary" v-if="type=='edit'" @click="submitForm('ruleForm')">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false"  title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMethod">确 定</el-button>
      </span>
    </el-dialog>
    <OrganDialog ref="organDia"></OrganDialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinOrgan } from '@/assets/js/mixin/organization';
import { mixinImport } from '@/assets/js/mixin/import';
import { mixinFormatter } from '@/assets/js/mixin/formatter';

export default {
  name: 'trainingRoom',
  mixins: [mixinList, mixinOrgan,mixinImport,mixinFormatter],
  data() {
    
    return {
      classRooms: [],
      
      formInline: {
        training_no: '',
        status: 'pass',
      },
      ruleForm: {
        term: '',
        serial_number:'',
        class_name: '',
        course_name:'',
        lesson_time: '',
        people_number:0,
        class_content:'',
        instrument:'',
        class_minute:0,
        teacher:'',
        comment:'',

        training_name: '',
        training_no: '',
      },
      rules: {
        serial_number: [{ required: true, message: '请输入编号', trigger: 'blur' }],
        term: [{ required: true, message: '请选择', trigger: 'change' }],
        class_name: [{ required: true, message: '请输入班级名称', trigger: 'blur' }],
        course_name: [{ required: true, message: '请输入课程名称', trigger: 'blur' }],
        teacher: [{ required: true, message: '请输入指导教师', trigger: 'blur' }],
        training_no: [{ required: true, message: `请选择${this.$store.state.themeTitle}室`, trigger: 'change' }],

        people_number: [
          { required: true, message: '人数不能为空' },
          { type: 'number', message: '人数必须为数字值' },
        ],
        instrument: [{ required: true, message: '请输入仪器及数量', trigger: 'blur' }],
        class_minute: [
          { required: true, message: '授课时长不能为空' },
        ],

        class_content: [{ required: true, message: '请输入课程内容', trigger: 'blur' }],

        

        lesson_time: [{  required: true, message: '请选择开始时间', trigger: 'change' }],

      },
      type: 'add',
      tableName: '实训日志',
      action:'',
      downloadUrl:'template/课程导入模版.xlsx',
      downloadName:'课程导入模版.xlsx'
    };
  },
  created() {
    this.action = `${this.baseUrlt}api/xmhy/class/plan/import`
  },
  mounted() {
    // this.getList();
    this.$store.dispatch('getTarinMent');
    this.$store.dispatch('getTermms');
  },
  methods: {
    onSubmit() {
      console.log('submit!');
    },
    handleInstituteChange(e) {
      console.log(e);
      this.ruleForm.institute_name = this.$until.getLabelName(this.institutes, 'isid', 'ismc', e);
    },
    async getTarinMent() {
      let res = await this.$api.instance.getTarinMent();
      if (res.code == 0) {
        this.classRooms = res.data;
      }
    },
    handleClassChange(e) {
      // this.ruleForm.room_id = e.id
      this.ruleForm.training_name = this.$until.getLabelName(this.$store.state.trainRooms, 'training_no', 'training_name', e);
    },
    handleSet() {
      this.centerDialogVisible = true;
    },
    handleClick() {
      this.centerDialogVisible = true;
    },
    handleBack() {
      this.$message.info('撤销中。。。');
    },
    handlePrint() {
      this.$message.info('打印中。。。');
    },
    async deleteMethod() {
      let params = { id: this.delid };
      let res = await this.$api.delet.deleteMethod(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    async createMethod() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      if (params.lesson_time) {
        let timee = params.lesson_time.getTime() / 1000;
        params.lesson_time = this.$until.getTimeStr(timee, '-');
      }
      let res = await this.$api.creat.createClassPlan(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async updateMethod() {
      let params = this.$until.easyDeepCopy(this.ruleForm);;
      let timee=''
      if (typeof params.lesson_time == 'string') {
        timee = new Date(params.lesson_time).getTime() / 1000;
        params.lesson_time = this.$until.getTimeStr(timee, '-');
      } else {
        timee = params.lesson_time.getTime() / 1000;
        params.lesson_time = this.$until.getTimeStr(timee, '-');
      }
      let res = await this.$api.update.updateClassPlan(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    // resetForm(formName) {
    //   this.$refs[formName].resetFields();
    // },
    submitForm(formName) {
      if(this.ruleForm.lesson_time){
        this.ruleForm.lesson_time = new Date(this.ruleForm.lesson_time)
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.type == 'add') {
            this.createMethod();
          } else if (this.type == 'edit') {
            this.updateMethod();
          }
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
    handleQuery() {
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    async getList() {
      let params = {
        page: this.$refs.pageChild.page,
        size: this.$refs.pageChild.size,
      };
      if (this.formInline.training_no) {
        params.training_no = this.formInline.training_no;
      }
      if (this.formInline.status) {
        params.status = this.formInline.status;
      }
      let res = await this.$api.query.getClassPlanList(params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
